import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class CachePolicyService {
  private readonly minute = 60 * 1000;
  private readonly day = 24 * 60 * 60 * 1000;

  getTtlMs(url: string): number {
    const normalized = url.toLowerCase();
    if (this.isDictionaryUrl(normalized)) {
      return 7 * this.day;
    }
    if (this.isDetailUrl(normalized)) {
      return 10 * this.minute;
    }
    return 5 * this.minute;
  }

  isCacheable(url: string): boolean {
    const normalized = url.toLowerCase();
    if (!normalized.includes('/api/')) {
      return false;
    }
    return !this.isSensitiveUrl(normalized);
  }

  private isDictionaryUrl(url: string): boolean {
    return /dictionar|countries|cities|regions|equipment_categories|vehicle_types|body_types|engine_types|fuel_types|colou?r/.test(url);
  }

  private isDetailUrl(url: string): boolean {
    const withoutQuery = url.split('?')[0];
    const parts = withoutQuery.split('/').filter(Boolean);
    return parts.length >= 3 && parts[0] === 'api';
  }

  private isSensitiveUrl(url: string): boolean {
    return /auth|login|logout|token|refresh|upload|jwt|notifications|conversations\/unread-count/.test(url)
      || /\/api\/(app-configs\/current|feature-flag-audiences\/)/.test(url)
      || /\/api\/(users|infos)(\/|$|\?)/.test(url);
  }
}
